import React from "react"
import { VerifyEmailPhone } from "./VerifyEmailPhone"
import { responsiveFontSizes, ThemeProvider } from "@material-ui/core"
import theme from "js/material-ui-theme"
import { managerApi } from "api/managerApi"
import { isNotNullOrEmpty } from "modules/utils/isNotNullOrEmpty"
import { isNullOrEmpty } from "modules/app/reactComponents/packing/sanitization-steps/components/presentation/validationsFunctions"

export type VerifyEmailPhoneContainerProps = {
    email?:string
    phone?:string
    goTo: (routeName:string) => void
}

export const VerifyEmailPhoneContainer = (props: VerifyEmailPhoneContainerProps) => {

    const [showSentMessage, setShowSentMessage] = React.useState(true) 

    return <>
        <ThemeProvider theme={theme}>
            <VerifyEmailPhone
                email={props.email}
                phone={props.phone}
                codesSent={showSentMessage}
                onConfirm={async () => {
                    if (isNotNullOrEmpty(props.email)) {
                        try {
                            await managerApi.UserIdha.confirmEmail(props.email)
                        } catch (error) {
                            console.error(error)
                        }
                    }

                    if (isNotNullOrEmpty(props.phone)) {
                        try {
                            await managerApi.UserIdha.confirmPhone(props.phone)
                        } catch (error) {
                            console.error(error)
                        }
                    }

                    setShowSentMessage(true)
                }}
                onVerify={async ({emailCode,phoneCode}) => {
                    const response = await managerApi.UserIdha.verifyIdentityData({
                        emailOrPhone: isNotNullOrEmpty(props.email) ? props.email : props.phone,
                        emailValidationToken: isNotNullOrEmpty(emailCode) ? emailCode : undefined,
                        phoneValidationToken: isNotNullOrEmpty(phoneCode) ? phoneCode : undefined,
                    })

                    const msg = response.emailVerified === true && response.phoneVerified ? `Email e telefone verificados com sucesso` : 
                                response.emailVerified === true ? `Email verificado com sucesso` :
                                response.phoneVerified === true ? `Telefone verificado com sucesso` :
                                `Códigos inválidos`

                    if (msg == `Códigos inválidos`) {
                        alert(msg)
                    } else {
                        props.goTo('login')
                    }
                                
                }}
                />
        </ThemeProvider>

    </>
}